import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { RecentClient } from '@store/models';

@Component({
    selector: 'app-recentclients',
    templateUrl: './recentclients.component.html',
    styleUrls: ['./recentclients.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})

export class RecentClientsComponent {

    @Input() recentClients: RecentClient[];
    @Output() selectClient = new EventEmitter<number>();

    onSelectClient(recentClient: RecentClient) {
        this.selectClient.emit(recentClient.recentClientDetails.kid);
    }
}
